// extracted by mini-css-extract-plugin
export default {"text":"BeautifulAddress__text--3EiJe","textEmail":"BeautifulAddress__textEmail--2tfAU"};